var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stripe-card-element"},[_c('div',{ref:"cardDiv",staticClass:"stripe-card-rendered"}),(_vm.error)?_c('el-alert',{staticClass:"mt-3",attrs:{"title":_vm.error,"type":"error","closable":false}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }